import React from "react"
import PropTypes from 'prop-types'
import GlobeMenu from './globeMenu'
import GlobeViz from './globeViz'

import * as style from './globe.module.scss'

class GlobeWrap extends React.Component {
  constructor() {
    super()
    this.state = {
      activeOffice: undefined,
      prevOffices: []
    }
    this.getNextOffice = this.getNextOffice.bind(this)
  }

  // spinny globe should "auto-play"
  componentDidMount() {
    this.timeout = setTimeout(() => {
      this.getNextOffice()
    }, 2500)

    this.interval = setInterval(() => {
      this.getNextOffice()
    }, 10000)
  }

  componentWillUnmount() {
    clearTimeout(this.timeout)
    clearInterval(this.interval)
  }
  
  getNextOffice() {
    const next = Math.floor((Math.random() * this.props.offices.length))

    // Reset offices if we've seen them all
    if (this.state.prevOffices.length === this.props.offices.length) {
      this.setState({prevOffices: []})
    }
    // Get another office if we've already seen it
    if (this.state.prevOffices.includes(next)) {
      this.getNextOffice()
      return
    }
    // spin the globe to the next office location
    this.setState(prevState => ({
      prevOffices: [...prevState.prevOffices, next],
      activeOffice: this.props.offices[next]
    }))
  }

  render() {
    const className = this.props.fullDisplay ? style.globeWrapFull : style.globeWrap
    return (
      <div className={className}>
        <h2 className="hidden-desktop">{this.props.title}</h2>
        <div className={style.colGlobe}>
          <GlobeViz office={this.state.activeOffice} />
        </div>
        <div className={style.colMenu}>
          <h2 className="hidden-mobile">{this.props.title}</h2>
          <GlobeMenu markets={this.props.officesByMarket} fullDisplay={this.props.fullDisplay} />
        </div>
      </div>
      )
  }
}

GlobeWrap.propTypes = {
  title: PropTypes.string.isRequired,
  offices: PropTypes.array.isRequired,
  officesByMarket: PropTypes.object.isRequired,
  fullDisplay: PropTypes.bool
}

export default GlobeWrap
